import React from 'react';
import styled from 'styled-components';
import { array, string, number } from 'prop-types';

import ProductItem from './ProductItem';

const ListContainer = styled.section`
  display: flex;
  justify-content: center;
  margin: 0px;
  width: 100%;
`;

const widthPercentage = (size) => {
  if (size === 1) {
    return 35;
  }

  return 100 / size;
};

const ProductsList = ({ products, posName, posDiscount, categoryBalance }) => (
  <ListContainer>
    {products.map(product => <ProductItem 
      key={product.type} 
      product={product} 
      posName={posName} 
      posDiscount={posDiscount} 
      categoryBalance={categoryBalance} 
      width={widthPercentage(products.length)}
    />)}
  </ListContainer>
);

ProductsList.propTypes = {
  products: array,
  posName: string.isRequired,
  posDiscount: number,
  categoryBalance: number,
};

ProductsList.defaultProps = {
  products: [],
  posDiscount: 0,
  categoryBalance: 0,
};

export default ProductsList;
